export const HEART_OCCURRING_EVENTS = {
    LowHeartRate: 'LowHeartRate',
    HighHeartRate: 'HighHeartRate',
    IrregularHeartRhythm: 'IrregularHeartRhythm'
};
const HeartEventRecipe = {
    $type$: 'Recipe',
    name: 'HeartEvent',
    rule: [
        {
            itemprop: 'occurredHeartEvent',
            itemtype: { type: 'string' }
        }
    ]
};
const HeartEventRecipes = [HeartEventRecipe];
export default HeartEventRecipes;
//# sourceMappingURL=HeartEventRecipes.js.map